import Vue from "vue";
import Router from "vue-router";
import Atlas from "./components/Atlas/Atlas";
import Auth from "./components/Auth/Auth";
import Login from "./components/Auth/Login";
import NotFound from "./components/shared/misc/NotFound";
import CRMDashboard from "./components/Atlas/CRM/CRMDashboard";
import CustomerList from "./components/Atlas/CRM/CustomerList";
import CustomerProfile from "./components/Atlas/CRM/CustomerProfile";
import CarrierList from "./components/Atlas/Billing/CarrierList/CarrierList";
import Carrier from "./components/Atlas/Billing/Carrier/Carrier";
import CarrierDestination from "./components/Atlas/Billing/CarrierDestination/CarrierDestination";
import CarrierArea from "./components/Atlas/Billing/CarrierArea/CarrierArea";
import Countries from "./components/Atlas/Billing/CountryList/CountryList";
import Currencies from "./components/Atlas/Billing/CurrencyList/CurrencyList";
import BooksellerList from "./components/Atlas/Distribution/BooksellerList/BooksellerList";
import WithdrawalPointList from "./components/Atlas/Distribution/WithdrawalPointList/WithdrawalPointList";
import DistributionDashboard from "./components/Atlas/Distribution/DistributionDashboard/DistributionDashboard";
import BillingDashboard from "./components/Atlas/Billing/BillingDashboard/BillingDashboard";
import DistributionOrderList from "./components/Atlas/Distribution/DistributionOrderList/DistributionOrderList";

Vue.use(Router);

// TODO: Retirer quand le push ne bugera plus au même niveau URL
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch(err => err);
};

// TODO: Retirer quand le replace ne bugera plus au même niveau URL
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(query, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalReplace.call(this, query, onResolve, onReject);
    }
    return originalReplace.call(this, query).catch(err => err);
};

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/auth",
            redirect: "/auth/login",
            name: "auth",
            component: Auth,
            children: [
                {
                    name: "login",
                    path: "login",
                    component: Login,
                },
            ],
        }, {
            path: "/",
            redirect: "/crm",
            name: "atlas",
            component: Atlas,
            children: [
                {
                    name: "crm",
                    path: "crm",
                    redirect: "/crm/dashboard",
                }, {
                    name: "crm-dashboard",
                    path: "crm/dashboard",
                    component: CRMDashboard,
                }, {
                    name: "customer-list",
                    path: "crm/customers",
                    component: CustomerList,
                }, {
                    name: "customer-profile",
                    path: "crm/customer",
                    component: CustomerProfile,
                }, {
                    name: "scanning",
                    path: "scanning",
                    redirect: "/scanning/dashboard",
                }, {
                    name: "scanning-dashboard",
                    path: "scanning/dashboard",
                }, {
                    name: "printing",
                    path: "printing",
                    redirect: "/printing/dashboard",
                }, {
                    name: "printing-dashboard",
                    path: "printing/dashboard",
                }, {
                    name: "stocks",
                    path: "stocks",
                    redirect: "/stocks/dashboard",
                }, {
                    name: "stocks-dashboard",
                    path: "stocks/dashboard",
                }, {
                    name: "distribution",
                    path: "distribution",
                    redirect: "/distribution/dashboard",
                }, {
                    name: "distribution-dashboard",
                    path: "distribution/dashboard",
                    component: DistributionDashboard,
                }, {
                    name: "distribution-orders",
                    path: "distribution/orders",
                    component: DistributionOrderList,
                }, {
                    name: "booksellers",
                    path: "distribution/booksellers",
                    component: BooksellerList,
                }, {
                    name: "withdrawal-points",
                    path: "distribution/withdrawal-points",
                    component: WithdrawalPointList,
                }, {
                    name: "shipping",
                    path: "shipping",
                    redirect: "/shipping/dashboard",
                }, {
                    name: "shipping-dashboard",
                    path: "shipping/dashboard",
                }, {
                    name: "billing",
                    path: "billing",
                    redirect: "/billing/dashboard",
                }, {
                    name: "billing-dashboard",
                    path: "billing/dashboard",
                    component: BillingDashboard,
                }, {
                    name: "carriers",
                    path: "billing/carriers",
                    component: CarrierList,
                }, {
                    name: "carrier",
                    path: "billing/carrier/:id",
                    component: Carrier,
                }, {
                    name: "carrier-destination",
                    path: "billing/carrier-destination/:id",
                    component: CarrierDestination,
                }, {
                    name: "carrier-area",
                    path: "billing/carrier-area/:id",
                    component: CarrierArea,
                }, {
                    name: "countries",
                    path: "billing/countries",
                    component: Countries,
                }, {
                    name: "currencies",
                    path: "billing/currencies",
                    component: Currencies,
                }, {
                    name: "statistics",
                    path: "statistics",
                    redirect: "/statistics/global",
                }, {
                    name: "global-statistics",
                    path: "statistics/global",
                },
            ],
        }, {
            path: "/404",
            component: NotFound,
        }, {
            path: "*",
            redirect: "/404",
        },
    ],
    scrollBehavior() {
        try {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } catch (e) {
            window.scrollTo(0, 0);
        }
    },
});

router.afterEach(() => {
    // eslint-disable-next-line no-undef
    $(".modal").modal("hide");
});

export default router;